module.exports = __webpack_public_path__ + "img/storyboard-guests_sl.9c7feb43.gif";